<template>
  <div class="container">
    <div class="scan-area">
      <video id="video" playsinline autoplay></video>
      <div class="scan-frame">
        <div class="scan-tip" v-show="scanTip">二维码模糊，请调整二维码位置</div>
        <div class="frame-corner corner-tl"></div>
        <div class="frame-corner corner-tr"></div>
        <div class="frame-corner corner-bl"></div>
        <div class="frame-corner corner-br"></div>
        <div class="scan-line"></div>
      </div>
    </div>
    <div class="controls">
      <button @click="switchCamera" class="btn" title="切换摄像头">
        <i class="fas fa-camera-rotate"></i>
      </button>
      <button id="captureBtn" class="btn btn-primary" title="扫码">
        <i class="fas fa-camera"></i>
      </button>
      <button id="toggleTorch" class="btn" @click="toggleTorch" title="手电筒">
        <i class="fas fa-lightbulb"></i>
      </button>
    </div>
  </div>
</template>
<script>
import { listH5Pages } from '@/api/h5Pages'
import { getDatabaseIsExits, listKHttpCode } from '@/api/kHttpCode'
import axios from 'axios'
export default {
  data() {
    return {
      video: null,
      stream: null,
      webpathz: 'http://b.kesiyuan.com/WeCat',
      currentFacingMode: 'environment',
      scanInterval: null,
      captureBtn: null,
      lastScanResult: '',
      scanTip: false,
      model: -1,//识别二维码模式（11：直接跳转二维码路径，12:识别到后走人工客服）
      downTotal: 20,//人工客服响应时间，
      fenBu: false,//是否停止人工客服,
      applet: {
        pages: [],
      },
      mimc: {
        mimc_appId: '2882303761517644081',
        mimc_appSecret: 'RWm2RxELBLPJmP7+6ESl1Q==',
        mimc_appKey: '5881764490081',
        mimc_appAccount: '',
        mimc_inter: false,
        user: {}

      },
      customerServiceObj: {
        customerServices: [],
        isXWOrWL: 0,
      }
    }
  },

  created() {
    this.model = this.$route.query.model
    this.applet.appletId = this.$route.query.appletId
    var index = new Date().getMilliseconds();
    this.mimc.mimc_appAccount = TEMPUSERS[index]
    axios.get('/WeCat/login/getloginUser').then(({ data, status }) => {
      this.customerServiceObj.customerServices = data.data
      this.login()
    })
    listH5Pages({ appletId: this.applet.appletId }).then(res => {
      this.applet.pages = res.data
    })
  },
  mounted() {
    this.video = document.getElementById('video');
    this.initCamera()
    setTimeout(() => {
      this.scanTip = true
      // weui.alert('请求超时，请重新验证')
    }, 5000)
  },
  methods: {
    // 切换手电筒（需要设备支持）
    async toggleTorch() {
      if (!this.stream) return;

      const track = this.stream.getVideoTracks()[0];
      if (!track || !track.getCapabilities) return;

      const capabilities = track.getCapabilities();
      if (!capabilities.torch) {
        alert('您的设备不支持手电筒功能');
        return;
      }

      try {
        this.torchEnabled = !this.torchEnabled;
        await track.applyConstraints({
          advanced: [{ torch: this.torchEnabled }]
        });

        alert(this.torchEnabled ? '手电筒已开启' : '手电筒已关闭');
      } catch (error) {
        console.error('手电筒切换失败:', error);
        alert('手电筒切换失败');
      }
    },
    async uploadImage(url) {
      if (!this.capturedCanvas) {
        // alert('没有可上传的图像');
        return;
      }

      try {
        // 将Canvas转换为Blob
        this.capturedCanvas.toBlob(async (blob) => {
          // 创建FormData
          const formData = new FormData();
          formData.append('file', blob, 'scan_result.jpg');
          formData.append('scanResult', this.lastScanResult || '未检测到二维码');
          formData.append('timestamp', new Date().toISOString())
          // 这里替换为您的服务器端API地址
          const serverUrl = '/prod-api/system/kHttpCode/common/uploadImage';

          // 发送请求到服务器
          const response = await fetch(serverUrl, {
            method: 'POST',
            body: formData
          });
          this.scanTip = false
          if (response.ok) {
            const result = await response.json()
            await this.onlineCustomerService(result.url, url)
            return result

          } else {
            throw new Error('服务器响应错误');
          }
        }, 'image/jpeg', 0.9);
      } catch (error) {
        console.error('上传失败:', error);
      }
    },
    switchCamera() {
      const newFacingMode = this.currentFacingMode === 'environment' ? 'user' : 'environment';
      this.initCamera(newFacingMode);
    },
    // 初始化摄像头
    async initCamera(facingMode = 'environment') {
      try {
        this.stopCamera();

        const constraints = {
          video: {
            facingMode: facingMode,
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        };

        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.video.srcObject = this.stream;
        this.currentFacingMode = facingMode;

        // 开始自动扫描
        this.startAutoScan();
      } catch (error) {
        console.error('摄像头访问失败:', error);
      }
    },
    // 开始自动扫描
    startAutoScan() {
      if (this.scanInterval) {
        clearInterval(this.scanInterval);
      }

      // 每500ms扫描一次
      this.scanInterval = setInterval(this.scanQRCode, 500);
    },
    // 停止摄像头
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }

      if (this.scanInterval) {
        clearInterval(this.scanInterval);
        this.scanInterval = null;
      }
    },
    showScanResult(result, imageUrl, errorMessage = null) {
      // alert(result)
      // this.uploadImage()
    },
    // 扫描二维码
    async scanQRCode() {
      if (!this.stream || this.video.readyState !== 4) return;

      // 创建Canvas用于图像处理
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // 设置Canvas尺寸与视频一致
      canvas.width = this.video.videoWidth;
      canvas.height = this.video.videoHeight;

      // 绘制视频帧到Canvas
      context.drawImage(this.video, 0, 0, canvas.width, canvas.height);

      // 获取图像数据
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

      // 使用jsQR库解码二维码
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });

      // 如果找到二维码
      if (code) {
        // 避免重复扫描相同结果
        if (code.data === this.lastScanResult) return;

        this.lastScanResult = code.data;

        // 停止自动扫描
        clearInterval(this.scanInterval);
        this.scanInterval = null;

        // 显示扫码结果
        this.showScanResult(code.data, canvas.toDataURL('image/jpeg'))
        if (this.model == 1) { //识别到二维码直接跳转
          location.href = code.data
        } else if (this.model == 2) { //纤维人工识别
          // 保存Canvas和图像数据用于上传
          this.capturedCanvas = canvas;
          this.capturedImageData = imageData;
          let imgSrc = await this.uploadImage(code.data)

        }
      }
    },
    async onlineCustomerService(imgSrc, qr) { //调用人工客服
      let qr_res = await listKHttpCode({ pageNum: 1, pageSize: 1, http: qr })
      if (qr_res.rows.length > 0) {
        let _kHttpCode = qr_res.rows.length > 0 ? qr_res.rows[0] : {}
        let _data = {
          "status": { "code": "4", "msg": "判真！" },
          "data": {
            "fullPath": imgSrc,
            "qr": qr,
            "productName": "柯斯样标Q2",
            "yourWl": [imgSrc],
            "myWl": [_kHttpCode.certificateImageUrl],
            "yourQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AWCRZAABn-wu7S3k763.jpg",
            "myQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AUgsfAABBQIntkB0806.jpg",
            "productLogo": "/group1/M00/A0/2F/Ch-a62kUXd-AfFcWAAB_wVa2O1U505.jpg",
            "productImgPath": "/group1/M00/A0/2F/Ch-a62kUXd-AekmmAAGTfbVwV_c596.jpg",
            "rate": 54,
            "type": 0,
            "addrssx": "北京市北京市",
            "adcode": "110100",
            "baseRate": 30,
            "showVideoPath": "",
            "showImgPath": "",
            "showGifPath": "",
            "videoType": "5",
            "qrScanningCount": 187
          }
        };

        // this.isXWOrWL = 1
        // this.applet.judgeModel = 2
        console.log('onlineCustomerService')
        this.rengong(_data)
        this.compared(_data, "2")
      }
    },
    rengong(res) {
      var timeCount = this.downTotal;
      var intervalobj = setInterval(() => {
        if (this.fenBu) {//当判定结果返回时停止定时器
          clearInterval(intervalobj);
        }
        if (timeCount == 0) {//当判定结果一直没返回时，显示超时
          // this.src1 = "images/yellow.png";
          // this.fenBuClass = 'font_yellow';
          // this.fenBuTxt = '无法判定';
          clearInterval(intervalobj);
          // weui.alert('请求超时，请重新验证', () => {
          //   setTimeout(() => {
          //     this.again();
          //   }, 500)
          // });
        }
        timeCount--;
        if (this.mimc.mimc_inter) {//当用户登录成功后才进行发送消息
          for (var i = 0; i < this.customerServiceObj.customerServices.length; i++) {//循环发给人工客服
            console.log(this.customerServiceObj.customerServices)
            this.sendMsg(this.customerServiceObj.customerServices[i].loginName, JSON.stringify(res.data))
          }
          this.mimc.mimc_inter = false;
        }
      }, 1000)
    },
    compared(res, pageType) {
      let _key = new Date().getTime()
      sessionStorage.setItem("KSY_RESULT_" + _key, JSON.stringify(res.data))
      let _page = this.applet.pages.find(item => { return item.pageType == pageType })
      this.$router.push({ path: '/main', query: { pageId: _page.pageId, key: _key, url: this.$route.query.url, appletId: this.$route.query.appletId } })
      this.stopCamera()
    },

    login() {
      this.mimc.user = new MIMCUser(this.mimc.mimc_appId, this.mimc.mimc_appAccount);
      this.mimc.user.registerP2PMsgHandler(this.receiveP2PMsg);//接收单聊消息回调
      this.mimc.user.registerFetchToken(this.fetchMIMCToken);//获取token回调
      this.mimc.user.registerStatusChange(this.statusChange);//登录结果回调
      this.mimc.user.registerServerAckHandler(this.serverAck);//发送消息后，服务器接收到消息ack的回调
      this.mimc.user.registerDisconnHandler(this.disconnect);//连接断开回调
      this.mimc.user.login();
    },
    //小米云通讯
    fetchMIMCToken() {
      let that = this;
      let sendData = { appId: that.mimc.mimc_appId, appKey: that.mimc.mimc_appKey, appSecret: that.mimc.mimc_appSecret, appAccount: that.mimc.mimc_appAccount };
      return that.httpRequest('https://mimc.chat.xiaomi.net/api/account/token', sendData);
    },
    httpRequest: function (url, data) {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, false);
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.send(JSON.stringify(data));
      return JSON.parse(xhr.response);
    },
    receiveP2PMsg(message) {//接收单聊消息回调  //N
      var that = this;
      var date = new Date(parseInt(message.getTimeStamp()));

      var disMsg = Base64;//new Base64();

      var msgData = JSON.parse(disMsg.decode(JSON.parse(message.getPayload()).content));
      var iobj = {
        data: {
          createTime: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds(),
          fullPath: msgData.fullPath,
          myWl: msgData.myWl,
          yourWl: msgData.yourWl,
          myQrAndWl: msgData.myQrAndWl,
          yourQrAndWl: msgData.yourQrAndWl,
          productImgPath: msgData.productImgPath,
          productLogo: msgData.productLogo,
          productName: msgData.productName,
          qr: msgData.qr,
          qrScanningCount: msgData.qrScanningCount,
          description: msgData.des,
          rate: msgData.rate,
          baseRate: msgData.baseRate,
          type: msgData.type
        },
        status: {
          code: msgData.newCode
        }
      }
      that.wenliCode = msgData.newCode;
      that.fenBu = true;
      if (msgData.newCode == 1) {//
        // that.src1 = "images/yellow.png";
        // that.fenBuClass = 'font_yellow';
        // that.fenBuTxt = '无法判定';
        // that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '不相符')
      } else if (msgData.newCode == 3) {//真
        // that.src1 = "images/green.png";
        // that.fenBuClass = 'font_blue';
        // that.fenBuTxt = '通过';
        // that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '相符')
      } else if (msgData.newCode == 4) {
        // that.src1 = "images/red.png";
        // that.fenBuClass = 'font_red';
        // that.fenBuTxt = '未通过';
        // that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '不相符')
      }
    },
    statusChange(bindResult, errType, errReason, errDesc) {//登录结果回调
      var that = this;
      if (bindResult) {
        that.mimc.mimc_inter = true;
        console.log("login succeed");
      } else {
        console.log("login failed.errReason=" + errReason + ",errDesc=" + errDesc + ",errType=" + errType);
      }
    },

    serverAck(packetId, sequence, timeStamp, errMsg) {//发送消息后，服务器接收到消息ack的回调
      //writeToScreens("receive msg ack:" + packetId + ",sequence=" + sequence + ",ts=" + timeStamp);
      return;
    },
    disconnect() {//连接断开回调
      var that = this;
      that.login();
    },
    logout() {//退出登录
      var that = this;
      that.user.logout();
    },
    sendMsg(toUser, message) {//发送单人消息
      var that = this;

      var a = Base64;//new Base64();
      var message_ = a.encode(message);
      var jsonMsg = String(JSON.stringify({
        version: 0,
        msgId: "TEXT_1234",
        msgType: 103,
        timestamp: String((new Date()).valueOf()),
        payload: message_,
        content: message_
      }));

      try {
        var packetId = that.mimc.user.sendMessage(toUser, jsonMsg);
      } catch (err) {
        console.log("sendMessage fail, err=" + err);
      }
      //that.chats.push(that.mimc_appAccount + " to " + toUser + ":" + message);
    },

    // judgeModel(that, res, code) {
    //   if (code == "1") {
    //     that.compared({ data: res.data }, "7")
    //   }
    //   else if (code == "2")
    //     that.compared(res, "8")
    //   else if (code == "3") {
    //     if (that.applet.judgeModel == 2) {
    //       that.rengong(that, res)
    //       that.compared(res, "2")
    //     } else
    //       that.compared(res, "2")
    //   }
    //   else if (code == "4") {
    //     //judgeModel: 1.消费者识别、不显示判定结果,2.后台人工识别,3.后台人工+自动,4.后台全自动
    //     if (that.applet.judgeModel == '1') {
    //       that.compared(res, "2")
    //     } else if (that.applet.judgeModel == '2' || that.applet.judgeModel == '3') {
    //       that.rengong(that, res)
    //       that.compared(res, "2")
    //     } else if (that.applet.judgeModel == '4') {
    //       that.compared(res, "2")
    //     }
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #121212;
  color: #fff;
  line-height: 1.5;
}

.container {
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.scan-area {
  flex: 1;
  position: relative;
  overflow: hidden;
  // background-color: #000;
}

#video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scan-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 250px;
  border: 2px solid #07C160;
  border-radius: 10px;
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.7);
}

.frame-corner {
  position: absolute;
  width: 30px;
  height: 30px;
  border-color: #07C160;
  border-style: solid;
}

.scan-tip {
  border: 2px solid #fea389;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: -50px;
  left: 50%;
  width: 110%;
  text-align: center;
  padding: 8px;
  border-radius: 34px;
  background: #f58756;
  transform: translateX(-50%);
}

.corner-tl {
  top: -2px;
  left: -2px;
  border-width: 4px 0 0 4px;
  border-radius: 10px 0 0 0;
}

.corner-tr {
  top: -2px;
  right: -2px;
  border-width: 4px 4px 0 0;
  border-radius: 0 10px 0 0;
}

.corner-bl {
  bottom: -2px;
  left: -2px;
  border-width: 0 0 4px 4px;
  border-radius: 0 0 0 10px;
}

.corner-br {
  bottom: -2px;
  right: -2px;
  border-width: 0 4px 4px 0;
  border-radius: 0 0 10px 0;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #07C160;
  box-shadow: 0px 0px 16px 6px #07c160;
  animation: scan 4s linear infinite;
}

@keyframes scan {
  0% {
    top: 0;
  }

  50% {
    top: calc(100% - 3px);
  }

  100% {
    top: 0;
  }
}

.controls {
  background-color: #1a1a1a;
  padding: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #333;
}

.btn {
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #07C160;
}

.btn:hover,
.btn:active {
  opacity: 0.9;
  transform: scale(0.98);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/scanQR/identify.vue